export default __webpack_public_path__ + "assets/models/a590e5ff2764437e9e5c7116fb03fd75.glb";